(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[640],{

/***/ 7879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9563);
/* harmony import */ var _BackButton_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6749);
/* harmony import */ var _BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5__);







function BackButton(param) {
    var fallback = param.fallback, className = param.className;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var currentSite = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .SitesContext */ .y).currentSite;
    var handleClick = function() {
        router.back();
    // todo: ideally we could use the 'fallback' prop to navigate to if we don't
    // have a 'back' state (i.e. new tab directly to URL)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default().container), className),
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default().btn)
        })
    });
}
BackButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    fallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
BackButton.defaultProps = {
    className: "",
    fallback: null
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 3825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/detect-browser/es/index.js
var es = __webpack_require__(3631);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/OutdatedBrowser/OutdatedBrowser.module.css
var OutdatedBrowser_module = __webpack_require__(5193);
var OutdatedBrowser_module_default = /*#__PURE__*/__webpack_require__.n(OutdatedBrowser_module);
;// CONCATENATED MODULE: ./components/OutdatedBrowser/index.js




function OutdatedBrowser(param) {
    var visible = param.visible;
    var ref = (0,react.useState)(visible), mounted = ref[0], setMounted = ref[1];
    var handleClick = function() {
        setMounted(false);
    };
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OutdatedBrowser_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (OutdatedBrowser_module_default()).title,
                children: "Your browser is out-of-date!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (OutdatedBrowser_module_default()).text,
                children: "Please update your browser to view this website correctly."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://browser-update.org/update-browser.html",
                target: "_blank",
                rel: "noopener noreferrer",
                className: (OutdatedBrowser_module_default()).link,
                children: "Update my browser"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (OutdatedBrowser_module_default()).btn,
                onClick: handleClick
            })
        ]
    });
}
OutdatedBrowser.propTypes = {
    visible: (prop_types_default()).bool
};
OutdatedBrowser.defaultProps = {
    visible: false
};
/* harmony default export */ var components_OutdatedBrowser = (OutdatedBrowser);

// EXTERNAL MODULE: ./components/Footer/index.js + 1 modules
var Footer = __webpack_require__(6195);
// EXTERNAL MODULE: ./components/Layout/Layout.module.css
var Layout_module = __webpack_require__(1627);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./components/Layout/index.js







function Layout(param) {
    var children = param.children, footerLess = param.footerLess, className = param.className, globalSettings = param.globalSettings, contentClassName = param.contentClassName;
    var browser = (0,es/* detect */.qY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OutdatedBrowser, {
                visible: browser && browser.name === "ie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "layout",
                className: classnames_default()((Layout_module_default()).main, contentClassName),
                children: children
            }),
            !footerLess && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                globalSettings: globalSettings
            })
        ]
    });
}
Layout.propTypes = {
    className: (prop_types_default()).string,
    footerLess: (prop_types_default()).bool,
    globalSettings: (prop_types_default()).object,
    contentClassName: (prop_types_default()).string
};
Layout.defaultProps = {
    footerLess: false,
    className: "",
    globalSettings: {},
    contentClassName: ""
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 5640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ModelPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/WordpressSEO/index.js
var WordpressSEO = __webpack_require__(1610);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/GlobalContextProvider.js + 6 modules
var GlobalContextProvider = __webpack_require__(260);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(7821);
// EXTERNAL MODULE: ./hooks/useClearTimeout.js
var useClearTimeout = __webpack_require__(662);
// EXTERNAL MODULE: ./components/ModelMeasurements/index.js
var ModelMeasurements = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./pages/[site]/model/model.module.css
var model_module = __webpack_require__(2309);
var model_module_default = /*#__PURE__*/__webpack_require__.n(model_module);
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(8509);
// EXTERNAL MODULE: ./components/Layout/index.js + 1 modules
var Layout = __webpack_require__(3825);
// EXTERNAL MODULE: ./components/BackButton/index.js
var BackButton = __webpack_require__(7879);
// EXTERNAL MODULE: ./components/Title/index.js
var Title = __webpack_require__(1382);
// EXTERNAL MODULE: ./components/AbbreviatedNumber/index.js
var AbbreviatedNumber = __webpack_require__(2062);
// EXTERNAL MODULE: ./components/InstagramCount/InstagramCount.module.css
var InstagramCount_module = __webpack_require__(5485);
var InstagramCount_module_default = /*#__PURE__*/__webpack_require__.n(InstagramCount_module);
;// CONCATENATED MODULE: ./components/InstagramCount/index.js






function isNameOverflow(width) {
    if (width > 90) {
        return (InstagramCount_module_default()).marquee;
    }
    return false;
}
function InstagramCount(param) {
    var instagram = param.instagram, colour = param.colour, className = param.className, iconClassName = param.iconClassName;
    var ref, ref1;
    var refText = (0,react.useRef)(null);
    if (!instagram || (instagram === null || instagram === void 0 ? void 0 : instagram.length) < 1) return null;
    var setUser = (ref = instagram[0]) === null || ref === void 0 ? void 0 : ref.username;
    var setCount = (ref1 = instagram[1]) === null || ref1 === void 0 ? void 0 : ref1.count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: "https://www.instagram.com/".concat(setUser),
        target: "_blank",
        rel: "reopener noreferrer",
        className: classnames_default()((InstagramCount_module_default()).container, className),
        style: {
            color: colour
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                className: classnames_default()((InstagramCount_module_default()).icon, iconClassName),
                fill: colour,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                })
            }),
            setCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (InstagramCount_module_default()).count,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AbbreviatedNumber/* default */.Z, {
                        children: setCount
                    }),
                    " followers"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InstagramCount_module_default()).user,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: refText,
                    className: classnames_default()((InstagramCount_module_default()).userText, isNameOverflow(refText.current ? refText.current.offsetWidth : 0)),
                    children: setUser
                })
            })
        ]
    });
}
InstagramCount.propTypes = {
    instagram: (prop_types_default()).array,
    colour: (prop_types_default()).string,
    className: (prop_types_default()).string,
    iconClassName: (prop_types_default()).string
};
InstagramCount.defaultProps = {
    instagram: [],
    colour: "",
    className: "",
    iconClassName: ""
};
/* harmony default export */ var components_InstagramCount = (InstagramCount);

// EXTERNAL MODULE: ./components/TiktokCount/TiktokCount.module.css
var TiktokCount_module = __webpack_require__(6667);
var TiktokCount_module_default = /*#__PURE__*/__webpack_require__.n(TiktokCount_module);
;// CONCATENATED MODULE: ./components/TiktokCount/index.js






function TiktokCount_isNameOverflow(width) {
    if (width > 90) {
        return (TiktokCount_module_default()).marquee;
    }
    return false;
}
var _NEXT_PUBLIC_ENABLE_TIKTOK;
var enableTikTok = parseInt((_NEXT_PUBLIC_ENABLE_TIKTOK = "1") !== null && _NEXT_PUBLIC_ENABLE_TIKTOK !== void 0 ? _NEXT_PUBLIC_ENABLE_TIKTOK : "0", 10) === 1;
var _NEXT_PUBLIC_ENABLE_TIKTOK_COUNT;
var enableTikTokCount = parseInt((_NEXT_PUBLIC_ENABLE_TIKTOK_COUNT = "0") !== null && _NEXT_PUBLIC_ENABLE_TIKTOK_COUNT !== void 0 ? _NEXT_PUBLIC_ENABLE_TIKTOK_COUNT : "0", 10) === 1;
function TiktokCount(param) {
    var tiktok = param.tiktok, colour = param.colour, className = param.className, iconClassName = param.iconClassName;
    var ref, ref1;
    if (!enableTikTok) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var refText = (0,react.useRef)(null);
    if (!tiktok || (tiktok === null || tiktok === void 0 ? void 0 : tiktok.length) < 1) return null;
    var setUser = (ref = tiktok[0]) === null || ref === void 0 ? void 0 : ref.username;
    var setCount = (ref1 = tiktok[1]) === null || ref1 === void 0 ? void 0 : ref1.count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: "https://www.tiktok.com/@".concat(setUser),
        target: "_blank",
        rel: "reopener noreferrer",
        className: classnames_default()((TiktokCount_module_default()).container, className),
        style: {
            color: colour
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "18",
                height: "20",
                viewBox: "0 0 18 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M17.8811 8.5693V5.06663C16.2408 5.06663 14.9889 4.6288 14.1811 3.7778C13.352 2.80658 12.8875 1.57664 12.8676 0.299797V0.0469636L9.5561 -0.0332031C9.5561 -0.0332031 9.5561 0.10863 9.5561 0.299797V14.1933C9.4425 14.814 9.14119 15.3849 8.69285 15.829C8.24451 16.273 7.67071 16.5688 7.04894 16.6764C6.42716 16.784 5.78733 16.6983 5.21584 16.4307C4.64434 16.1632 4.1687 15.7267 3.85311 15.1803C3.53752 14.6339 3.39719 14.0037 3.45106 13.375C3.50492 12.7463 3.7504 12.1493 4.15434 11.6645C4.55828 11.1797 5.10124 10.8305 5.70992 10.6641C6.3186 10.4977 6.96369 10.522 7.5581 10.7338V7.34213C7.21152 7.28534 6.86095 7.25647 6.50976 7.2558C5.2462 7.2558 4.01102 7.63049 2.96041 8.33248C1.9098 9.03448 1.09095 10.0323 0.607405 11.1996C0.123862 12.367 -0.00265501 13.6516 0.243853 14.8908C0.490361 16.1301 1.09882 17.2685 1.99229 18.1619C2.88576 19.0554 4.02412 19.6639 5.2634 19.9104C6.50268 20.1569 7.78722 20.0304 8.9546 19.5468C10.122 19.0633 11.1198 18.2444 11.8217 17.1938C12.5237 16.1432 12.8984 14.908 12.8984 13.6445C12.8977 13.3827 12.8813 13.1211 12.8491 12.8613V7.2188C14.3549 8.15918 16.1068 8.62936 17.8811 8.5693Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TiktokCount_module_default()).user,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: refText,
                    className: classnames_default()((TiktokCount_module_default()).userText, TiktokCount_isNameOverflow(refText.current ? refText.current.offsetWidth : 0)),
                    children: setUser
                })
            }),
            enableTikTokCount && setCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (TiktokCount_module_default()).count,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AbbreviatedNumber/* default */.Z, {
                        children: setCount
                    }),
                    " followers"
                ]
            })
        ]
    });
}
TiktokCount.propTypes = {
    tiktok: (prop_types_default()).array,
    colour: (prop_types_default()).string,
    className: (prop_types_default()).string,
    iconClassName: (prop_types_default()).string
};
TiktokCount.defaultProps = {
    tiktok: [],
    colour: "",
    className: "",
    iconClassName: ""
};
/* harmony default export */ var components_TiktokCount = (TiktokCount);

// EXTERNAL MODULE: ./node_modules/react-collapse/lib/index.js
var lib = __webpack_require__(6180);
// EXTERNAL MODULE: ./components/ModelHeader/HeaderBio/HeaderBio.module.css
var HeaderBio_module = __webpack_require__(2085);
var HeaderBio_module_default = /*#__PURE__*/__webpack_require__.n(HeaderBio_module);
;// CONCATENATED MODULE: ./components/ModelHeader/HeaderBio/index.js





function cleanBio(bio) {
    if (bio === null) {
        return "";
    }
    var cleanedBio = bio.replace(/<p>/g, "");
    var cleanedBioParts = cleanedBio.split(/<\/p>?\r*\n*/);
    return cleanedBioParts.filter(function(line) {
        return line !== "" && line !== "&nbsp;";
    }).map(function(line) {
        return "<p>".concat(line, "</p>\n");
    }).join("");
}
function isBioEmpty(bio) {
    return bio === null || bio === "";
}
function HeaderBio(props) {
    var bio = props.bio, minHeight = props.minHeight, imgHalfRef = props.imgHalfRef, titleContainerRef = props.titleContainerRef;
    var cleanedBio = (0,react.useMemo)(function() {
        return cleanBio(bio);
    }, [
        bio
    ]);
    if (isBioEmpty(cleanedBio)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var bioTextRef = (0,react.useRef)();
    var bioContainerRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), isExpandable = ref[0], setIsExpandable = ref[1];
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var ref2 = (0,react.useState)(minHeight), height = ref2[0], setHeight = ref2[1];
    var ref3 = (0,react.useState)(400), maxHeight = ref3[0], setMaxHeight = ref3[1];
    (0,react.useEffect)(function() {}, []);
    (0,react.useEffect)(function() {
        var handleResize = function() {
            if (!imgHalfRef || !titleContainerRef || !bioTextRef) {
                return;
            }
            var paddingHeight = 30;
            var readMoreHeight = 16;
            var imgHeight = imgHalfRef.current.clientHeight;
            var titleContainerHeight = titleContainerRef.current.clientHeight;
            var bioTextHeight = bioTextRef.current.clientHeight;
            var bioContentHeight = imgHeight - titleContainerHeight - readMoreHeight - paddingHeight * 2;
            setIsExpandable(bioTextHeight > minHeight);
            if (isExpanded) {
                setHeight(bioContentHeight);
            }
            setMaxHeight(bioContentHeight);
        };
        window.addEventListener("resize", handleResize);
        // Call the function initially to set the state based on the initial size
        handleResize();
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, [
        imgHalfRef,
        titleContainerRef,
        bioTextRef,
        isExpanded
    ]);
    var handleClick = function() {
        var nowIsExpanded = !isExpanded;
        setHeight(nowIsExpanded ? maxHeight : minHeight);
        setIsExpanded(nowIsExpanded);
        if (bioContainerRef.current) {
            bioContainerRef.current.scrollTop = 0;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HeaderBio_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: height,
                    overflow: isExpanded ? "scroll" : "hidden"
                },
                className: (HeaderBio_module_default()).container,
                ref: bioContainerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: cleanedBio
                    },
                    ref: bioTextRef
                })
            }),
            isExpandable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (HeaderBio_module_default()).collapse,
                onClick: handleClick,
                children: [
                    isExpanded ? "Collapse" : "Read More",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "aria-hidden": true,
                        className: (HeaderBio_module_default()).expander,
                        children: isExpanded ? "-" : "+"
                    })
                ]
            })
        ]
    });
}
HeaderBio.propTypes = {
    bio: (prop_types_default()).string,
    minHeight: (prop_types_default()).number,
    imgHalfRef: (prop_types_default()).object,
    titleContainerRef: (prop_types_default()).object
};
HeaderBio.defaultProps = {
    bio: "",
    minHeight: 100,
    imgHalfRef: null,
    titleContainerRef: null
};
/* harmony default export */ var ModelHeader_HeaderBio = (HeaderBio);

// EXTERNAL MODULE: ./components/ModelHeader/ModelHeader.module.css
var ModelHeader_module = __webpack_require__(286);
var ModelHeader_module_default = /*#__PURE__*/__webpack_require__.n(ModelHeader_module);
;// CONCATENATED MODULE: ./components/ModelHeader/index.js





// import CloudinarySolarnetImage from 'components/CloudinarySolarnetImage'





function ModelHeader(param) {
    var firstName = param.firstName, lastName = param.lastName, coverImage = param.coverImage, bio = param.bio, instagram = param.instagram, tiktok = param.tiktok, uiColour = param.uiColour;
    var imgHalfRef = (0,react.useRef)(null);
    var titleContainerRef = (0,react.useRef)(null);
    var state = (0,react.useContext)(GlobalContextProvider/* GlobalStateContext */.Pn);
    if (!coverImage) return null;
    // Forcing the character case because client doesn't want to change in CMS.
    var name = "".concat((firstName === null || firstName === void 0 ? void 0 : firstName.toLowerCase()) || "", " ").concat((lastName === null || lastName === void 0 ? void 0 : lastName.toLowerCase()) || "");
    // NOTE: This has been added quckly to get a retina version of the header image.
    // If more time was allocated I would look at using 'dpr_auto' and the Cloudinary React SDK
    // to handle images.
    var cloudinaryUrl = "https://res.cloudinary.com/select-models/image/fetch/w_2560,c_limit";
    var ratio = "3:4";
    var imgNormal = "".concat(cloudinaryUrl, "/w_1.0,c_fit,ar_").concat(ratio, ",f_auto,q_auto:best/").concat(coverImage);
    var imgRetina = "".concat(cloudinaryUrl, "/w_1.0,c_fit,ar_").concat(ratio, ",f_auto,q_auto:best,dpr_2.0/").concat(coverImage);
    var setImage = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imgNormal,
        srcSet: "".concat(imgNormal, " 1x, ").concat(imgRetina, " 2x"),
        alt: name,
        className: (ModelHeader_module_default()).img
    });
    var renderImage = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ModelHeader_module_default()).imgHalfWrap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelHeader_module_default()).imgHalf,
                ref: imgHalfRef,
                children: setImage
            })
        });
    };
    // const headerBackground =
    //   headerColour && headerColour === 'light' ? '#000' : '#fff'
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ModelHeader_module_default()).container, (ModelHeader_module_default()).containerPortrait),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelHeader_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ModelHeader_module_default()).textContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ModelHeader_module_default()).titleContainer,
                            ref: titleContainerRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    className: (ModelHeader_module_default()).title,
                                    title: firstName,
                                    subtitle: lastName,
                                    lightUi: uiColour === true,
                                    shrinkSubtitleLength: 15
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ModelHeader_module_default()).socialStats,
                                    children: [
                                        instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InstagramCount, {
                                            instagram: instagram,
                                            colour: uiColour === true ? "#fff" : "#000"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TiktokCount, {
                                            tiktok: tiktok,
                                            colour: uiColour === true ? "#fff" : "#000"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelHeader_HeaderBio, {
                            bio: bio,
                            imgHalfRef: imgHalfRef,
                            titleContainerRef: titleContainerRef
                        })
                    ]
                })
            }),
            renderImage()
        ]
    });
}
ModelHeader.propTypes = {
    firstName: (prop_types_default()).string,
    lastName: (prop_types_default()).string,
    coverImage: (prop_types_default()).string,
    bio: (prop_types_default()).string,
    instagram: (prop_types_default()).array,
    tiktok: (prop_types_default()).array,
    uiColour: (prop_types_default()).bool
};
ModelHeader.defaultProps = {
    firstName: "",
    lastName: "",
    coverImage: null,
    bio: "",
    instagram: [],
    tiktok: [],
    uiColour: false
};
/* harmony default export */ var components_ModelHeader = (ModelHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react-scrollspy/lib/scrollspy.js
var scrollspy = __webpack_require__(9986);
;// CONCATENATED MODULE: ./helpers/throttle.js
function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    var _this = this;
    var timer = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (timer === null) {
            timer = setTimeout(function() {
                func.apply(_this, args);
                timer = null;
            }, wait);
        }
    };
}

;// CONCATENATED MODULE: ./hooks/useDocumentScrollThrottled.js



function useDocumentScrollThrottled(callback) {
    var handleDocumentScroll = function handleDocumentScroll() {
        var ref = document.documentElement || document.body, currentScrollTop = ref.scrollTop;
        setScrollPosition(function(previousPosition) {
            previousScrollTop = previousPosition;
            return currentScrollTop;
        });
        callback({
            previousScrollTop: previousScrollTop,
            currentScrollTop: currentScrollTop
        });
    };
    var state = (0,react.useContext)(GlobalContextProvider/* GlobalStateContext */.Pn);
    var hasWindow =  true && window;
    var ref = (0,react.useState)(0), setScrollPosition = ref[1];
    var previousScrollTop = 0;
    var handleDocumentScrollThrottled = throttle(handleDocumentScroll, 250);
    (0,react.useEffect)(function() {
        hasWindow && window.addEventListener("scroll", handleDocumentScrollThrottled);
        return function() {
            return hasWindow && window.removeEventListener("scroll", handleDocumentScrollThrottled);
        };
    }, [
        hasWindow,
        state
    ]);
}
/* harmony default export */ var hooks_useDocumentScrollThrottled = (useDocumentScrollThrottled);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(2951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
// EXTERNAL MODULE: ./components/ModelContent/Video/Video.module.css
var Video_module = __webpack_require__(584);
var Video_module_default = /*#__PURE__*/__webpack_require__.n(Video_module);
;// CONCATENATED MODULE: ./components/ModelContent/Video/index.js








var Video = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Video, Component);
    var _super = (0,_create_super/* default */.Z)(Video);
    function Video(props) {
        (0,_class_call_check/* default */.Z)(this, Video);
        var _this;
        _this = _super.call(this, props);
        _this.video = props.video;
        return _this;
    }
    (0,_create_class/* default */.Z)(Video, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    className: (Video_module_default()).video,
                    autoPlay: true,
                    playsInline: true,
                    muted: true,
                    loop: true,
                    controls: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: this.video.sourceUrl,
                        type: this.video.videoType
                    })
                }, this.video.sourceUrl);
            }
        }
    ]);
    return Video;
}(react.Component);
Video.propTypes = {
    video: (prop_types_default()).object
};
Video.defaultProps = {
    video: {}
};
/* harmony default export */ var ModelContent_Video = (Video);

;// CONCATENATED MODULE: ./components/ModelContent/Videos/index.js




function Videos(param) {
    var videos = param.videos;
    if ((videos === null || videos === void 0 ? void 0 : videos.length) < 1) return null;
    return videos.map(function(video, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Video, {
            video: video
        }, "".concat(video.sourceUrl).concat(index));
    });
}
Videos.propTypes = {
    videos: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        videoType: (prop_types_default()).string
    }))
};
Videos.defaultProps = {
    videos: []
};
/* harmony default export */ var ModelContent_Videos = (Videos);

// EXTERNAL MODULE: ./context/SitesContextProvider.js
var SitesContextProvider = __webpack_require__(9563);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./components/ImageGroup/index.js








var ImageGroup = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ImageGroup, _Component);
    var _super = (0,_create_super/* default */.Z)(ImageGroup);
    function ImageGroup(props) {
        (0,_class_call_check/* default */.Z)(this, ImageGroup);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleLoad", function(index, w, h) {
            var ratios = _this.state.ratios;
            ratios[index] = h / w;
            _this.setState({
                ratios: ratios
            }, _this.checkImagesReady);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "checkImagesReady", function() {
            var ratios = _this.state.ratios;
            if (ratios.length === 2 && ratios[0] !== ratios[1]) {
                _this.setState({
                    elementToResize: ratios[0] < ratios[1] ? 0 : 1,
                    ratio: ratios[0] > ratios[1] ? ratios[0] : ratios[1]
                });
            }
        });
        _this.state = {
            ratios: [],
            elementToResize: null,
            ratio: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ImageGroup, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className;
                var _state = this.state, elementToResize = _state.elementToResize, ratio = _state.ratio;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: className,
                    children: children(this.handleLoad, elementToResize, ratio)
                });
            }
        }
    ]);
    return ImageGroup;
}(react.Component);
/* harmony default export */ var components_ImageGroup = (ImageGroup);

// EXTERNAL MODULE: ./components/ModelContent/Portfolio/Portfolio.module.css
var Portfolio_module = __webpack_require__(5199);
var Portfolio_module_default = /*#__PURE__*/__webpack_require__.n(Portfolio_module);
;// CONCATENATED MODULE: ./helpers/isSingleRowItem.js
var isSingleRowItem = function(asset) {
    return "videoType" in asset || parseInt(asset.orientation, 10) === 2;
};
/* harmony default export */ var helpers_isSingleRowItem = (isSingleRowItem);

;// CONCATENATED MODULE: ./helpers/createGalleryRows.js

var createGalleryRows = function(assets) {
    var rows = [];
    var columnMax = 2;
    var row = [];
    assets === null || assets === void 0 ? void 0 : assets.forEach(function(asset, index) {
        if (helpers_isSingleRowItem(asset)) {
            if (row.length > 0) {
                rows.push(row);
            }
            rows.push([
                asset
            ]);
            row = [];
        } else {
            row.push(asset);
        }
        if (row.length === columnMax || index === assets.length - 1) {
            rows.push(row);
            row = [];
        }
    });
    return rows;
};
/* harmony default export */ var helpers_createGalleryRows = (createGalleryRows);

;// CONCATENATED MODULE: ./components/ModelContent/Portfolio/index.js







// import CloudinarySolarnetImage from 'components/CloudinarySolarnetImage'




// TODO: Add alt to images.
function Portfolio(param) {
    var images = param.images, // lightboxImageIds,
    // addToLightbox,
    isPortraitImg = param.isPortraitImg, fallbackImg = param.fallbackImg, customBook = param.customBook;
    if ((images === null || images === void 0 ? void 0 : images.length) < 1) return null;
    var useImages = isPortraitImg === true || fallbackImg === true ? images.slice(1) : images;
    var rows = helpers_createGalleryRows(useImages);
    return rows.map(function(row, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImageGroup, {
            className: (Portfolio_module_default()).row,
            children: function(handleLoad, indexToResize, ratio) {
                return row.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Portfolio_module_default()).imageWrapper, (0,_define_property/* default */.Z)({}, (Portfolio_module_default()).imageWrapperLandscape, helpers_isSingleRowItem(image))),
                        children: [
                            "videoType" in image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Video, {
                                video: image
                            }),
                            !("videoType" in image) && index === indexToResize && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Portfolio_module_default()).imageRatio,
                                style: {
                                    paddingTop: "".concat(ratio * 100, "%")
                                }
                            }),
                            !("videoType" in image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image.sourceUrl,
                                className: classnames_default()((Portfolio_module_default()).image, (0,_define_property/* default */.Z)({}, (Portfolio_module_default()).imageResized, index === indexToResize)),
                                alt: ""
                            })
                        ]
                    }, "".concat(image.sourceUrl).concat(index));
                });
            }
        }, "".concat(row.sourceUrl).concat(index));
    });
}
Portfolio.propTypes = {
    images: (prop_types_default()).array,
    lightboxImageIds: (prop_types_default()).array,
    addToLightbox: (prop_types_default()).func,
    isPortraitImg: (prop_types_default()).bool,
    fallbackImg: (prop_types_default()).bool,
    customBook: (prop_types_default()).bool
};
Portfolio.defaultProps = {
    images: [],
    lightboxImageIds: [],
    addToLightbox: function() {},
    isPortraitImg: false,
    fallbackImg: false,
    customBook: false
};
/* harmony default export */ var ModelContent_Portfolio = (Portfolio);

// EXTERNAL MODULE: ./components/ModelContent/Polaroids/Polaroids.module.css
var Polaroids_module = __webpack_require__(6544);
var Polaroids_module_default = /*#__PURE__*/__webpack_require__.n(Polaroids_module);
;// CONCATENATED MODULE: ./components/ModelContent/Polaroids/index.js





// import CloudinarySolarnetImage from 'components/CloudinarySolarnetImage'

// TODO: Add alt to images.
function Polaroids(param) {
    var images = param.images;
    if ((images === null || images === void 0 ? void 0 : images.length) < 1) return null;
    var rows = [];
    images.forEach(function(img) {
        if (rows.length === 0 || parseInt(img.orientation, 10) === 4 || parseInt(rows[rows.length - 1][0].orientation, 10) === 4 || rows[rows.length - 1].length === 4) rows.push([
            img
        ]);
        else rows[rows.length - 1].push(img);
    });
    return rows.map(function(row) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImageGroup, {
            className: (Polaroids_module_default()).row,
            children: function(handleLoad, indexToResize, ratio) {
                return row.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Polaroids_module_default()).imageWrapper, (0,_define_property/* default */.Z)({}, (Polaroids_module_default()).imageWrapperLandscape, parseInt(image.orientation, 10) === 4)),
                        children: [
                            index === indexToResize && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Polaroids_module_default()).imageRatio,
                                style: {
                                    paddingTop: "".concat(ratio * 100, "%")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image.sourceUrl,
                                className: classnames_default()((Polaroids_module_default()).image, (0,_define_property/* default */.Z)({}, (Polaroids_module_default()).imageResized, index === indexToResize)),
                                alt: ""
                            })
                        ]
                    }, image.sourceUrl);
                });
            }
        }, row[0].sourceUrl);
    });
}
Polaroids.propTypes = {
    images: (prop_types_default()).array
};
Polaroids.defaultProps = {
    images: []
};
/* harmony default export */ var ModelContent_Polaroids = (Polaroids);

// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var react_lazyload_lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./components/ModelContent/LightboxButton/LightboxButton.module.css
var LightboxButton_module = __webpack_require__(3128);
var LightboxButton_module_default = /*#__PURE__*/__webpack_require__.n(LightboxButton_module);
;// CONCATENATED MODULE: ./components/ModelContent/LightboxButton/index.js




function LightboxButton(param) {
    var image = param.image, onClick = param.onClick, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: function() {
            return onClick(image.id, image.original_src, image.orientation);
        },
        className: classnames_default()((LightboxButton_module_default()).container, "lightboxButton"),
        disabled: disabled,
        children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "44",
            height: "44",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            id: "b",
                            cx: "17",
                            cy: "17",
                            r: "17"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "a",
                            width: "141.2%",
                            height: "141.2%",
                            x: "-20.6%",
                            y: "-14.7%",
                            filterUnits: "objectBoundingBox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "2",
                                    in: "SourceAlpha",
                                    result: "shadowOffsetOuter1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    in: "shadowOffsetOuter1",
                                    result: "shadowBlurOuter1",
                                    stdDeviation: "2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "shadowBlurOuter1",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(5 4)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                    fill: "#000",
                                    filter: "url(#a)",
                                    xlinkHref: "#b"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                    fill: "#FFF",
                                    xlinkHref: "#b"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#979797",
                            fillRule: "nonzero",
                            d: "M29.5 16l-8.749 9.12-4.418-4.32L15 22.5l5.751 5.5L31 17.44z"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "42",
            height: "42",
            viewBox: "0 0 42 42",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            id: "b",
                            cx: "17",
                            cy: "17",
                            r: "17"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "a",
                            width: "141.2%",
                            height: "141.2%",
                            x: "-20.6%",
                            y: "-14.7%",
                            filterUnits: "objectBoundingBox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "2",
                                    in: "SourceAlpha",
                                    result: "shadowOffsetOuter1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    in: "shadowOffsetOuter1",
                                    result: "shadowBlurOuter1",
                                    stdDeviation: "2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "shadowBlurOuter1",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "c",
                            d: "M0 5h11v2H0z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "d",
                            d: "M0 5h11v2H0z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    transform: "translate(4 2)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            fill: "#000",
                            filter: "url(#a)",
                            xlinkHref: "#b"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            fill: "#FFF",
                            xlinkHref: "#b"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(12 11)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                    fill: "#D8D8D8",
                                    xlinkHref: "#c"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "#979797",
                                    d: "M.5 5.5h10v1H.5z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    transform: "rotate(90 5.5 6)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                            fill: "#D8D8D8",
                                            xlinkHref: "#d"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            stroke: "#979797",
                                            d: "M.5 5.5h10v1H.5z"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
LightboxButton.propTypes = {
    image: (prop_types_default()).object,
    onClick: (prop_types_default()).func,
    disabled: (prop_types_default()).bool
};
LightboxButton.defaultProps = {
    image: {},
    onClick: function() {},
    disabled: false
};
/* harmony default export */ var ModelContent_LightboxButton = (LightboxButton);

// EXTERNAL MODULE: ./components/ModelContent/Covers/Covers.module.css
var Covers_module = __webpack_require__(9855);
var Covers_module_default = /*#__PURE__*/__webpack_require__.n(Covers_module);
;// CONCATENATED MODULE: ./components/ModelContent/Covers/index.js





function Covers(param) {
    var images = param.images, lightboxImageIds = param.lightboxImageIds, addToLightbox = param.addToLightbox;
    if ((images === null || images === void 0 ? void 0 : images.length) < 1) return null;
    var rows = images.map(function(e, i) {
        return i % 3 === 0 ? images.slice(i, i + 3) : null;
    }).filter(function(i) {
        return i;
    });
    return rows.map(function(row, rowIndex) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Covers_module_default()).row,
            children: row.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Covers_module_default()).imageWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Covers_module_default()).imageBackground,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_lazyload_lib/* default */.ZP, {
                                offset: 200,
                                once: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image.url,
                                    className: (Covers_module_default()).image
                                }, image.url)
                            })
                        }),
                        lightboxImageIds && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_LightboxButton, {
                            image: image,
                            disabled: lightboxImageIds.includes(image.id),
                            onClick: addToLightbox
                        })
                    ]
                }, image.url);
            })
        }, "".concat(row[0].url, "_").concat(rowIndex));
    });
}
Covers.propTypes = {
    images: (prop_types_default()).array,
    lightboxImageIds: (prop_types_default()).array,
    addToLightbox: (prop_types_default()).func
};
Covers.defaultProps = {
    images: [],
    lightboxImageIds: [],
    addToLightbox: function() {}
};
/* harmony default export */ var ModelContent_Covers = (Covers);

// EXTERNAL MODULE: ./components/ModelContent/Bio/Bio.module.css
var Bio_module = __webpack_require__(888);
var Bio_module_default = /*#__PURE__*/__webpack_require__.n(Bio_module);
;// CONCATENATED MODULE: ./components/ModelContent/Bio/index.js



function Bio(param) {
    var bio = param.bio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Bio_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Bio_module_default()).container,
            dangerouslySetInnerHTML: {
                __html: bio
            }
        })
    });
}
Bio.propTypes = {
    bio: (prop_types_default()).string
};
Bio.defaultProps = {
    bio: ""
};
/* harmony default export */ var ModelContent_Bio = (Bio);

// EXTERNAL MODULE: ./components/ModelContent/ModelContent.module.css
var ModelContent_module = __webpack_require__(359);
var ModelContent_module_default = /*#__PURE__*/__webpack_require__.n(ModelContent_module);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/ModelContent/index.js














function ModelContent(_param) {
    var allContent = _param.allContent, fallbackImg = _param.fallbackImg, props = (0,_object_without_properties/* default */.Z)(_param, [
        "allContent",
        "fallbackImg"
    ]);
    var content = function(id, name, positionCounter, children) {
        // Now that bio comes first, we have to make sure that portfolio is always opened
        var initialState = id === "portfolio";
        var ref = (0,react.useState)(initialState), isButtonCollapseOpen = ref[0], setIsButtonCollapseOpen = ref[1];
        var onClick = (0,react.useCallback)(function() {
            return setIsButtonCollapseOpen(!isButtonCollapseOpen);
        }, [
            isButtonCollapseOpen
        ]);
        var windowSize = (0,useWindowSize/* default */.Z)();
        var isMobile = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 900;
        var isOpened = !isMobile || isButtonCollapseOpen;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: id,
            className: (ModelContent_module_default()).row,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: (ModelContent_module_default()).title,
                    onClick: onClick,
                    children: [
                        name,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            className: (ModelContent_module_default()).expander,
                            children: isButtonCollapseOpen ? "+" : "-"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Collapse, {
                    isOpened: isOpened,
                    children: children
                })
            ]
        }, positionCounter.toString());
    };
    var positionCounter = 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ModelContent_module_default()).container,
        children: allContent.map(function(contentItem) {
            var component = null;
            if (contentItem.type === "bio") {
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Bio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    bio: contentItem.bio
                }));
            } else if (contentItem.type === "polaroids") {
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Polaroids, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    images: contentItem.assets
                }));
            } else if (contentItem.type === "covers") {
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Covers, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    images: contentItem.assets
                }));
            } else if (contentItem.type === "campaigns") {
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Portfolio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    images: contentItem.assets,
                    fallbackImg: false,
                    customBook: true
                }));
            } else if (contentItem.type === "video") {
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Videos, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    videos: contentItem.assets
                }));
            } else if (contentItem.type === "books") {
                if (contentItem.slug === "video" || contentItem.slug === "videos") {
                    component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Videos, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        videos: contentItem.assets
                    }));
                } else {
                    component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Portfolio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        images: contentItem.assets
                    }));
                }
            } else if (contentItem.type === "portfolio") {
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Portfolio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    images: contentItem.assets,
                    fallbackImg: fallbackImg
                }));
            } else {
                // Always fall back to Portfolio component if there isn't a specific one
                component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelContent_Portfolio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    images: contentItem.assets
                }));
            }
            return content(contentItem.scrollSpyId, contentItem.typeName, positionCounter++, component);
        })
    });
}
ModelContent.propTypes = {
    allContent: (prop_types_default()).array,
    fallbackImg: (prop_types_default()).bool
};
ModelContent.defaultProps = {
    allContent: [],
    fallbackImg: false
};
/* harmony default export */ var components_ModelContent = (ModelContent);

;// CONCATENATED MODULE: ./components/ModelGallery/download.svg
/* harmony default export */ var download = ({"src":"/_next/static/media/download.340d34c5.svg","height":800,"width":800});
// EXTERNAL MODULE: ./components/ModelGallery/ModelGallery.module.css
var ModelGallery_module = __webpack_require__(6128);
var ModelGallery_module_default = /*#__PURE__*/__webpack_require__.n(ModelGallery_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/ModelGallery/index.js













// import ModelPdfButton from '../ModelPdfButton';






var ModelGallery = function(param) {
    var fallbackImg = param.fallbackImg, instagram = param.instagram, tiktok = param.tiktok, firstName = param.firstName, lastName = param.lastName, galleries = param.galleries, props = param.props;
    var toggleEmails = function toggleEmails(e) {
        e.preventDefault();
        setEmailsVisible(true);
    };
    var router = (0,next_router.useRouter)();
    var site = router.query.site;
    var books = props.books, videos = props.videos, url = props.url, activeSection = props.activeSection, bookers = props.bookers, bio = props.bio, slug = props.slug;
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var ref1 = (0,react.useState)(false), emailsVisible = ref1[0], setEmailsVisible = ref1[1];
    hooks_useDocumentScrollThrottled(function(callbackData) {
        var windowPosition = window.innerHeight * 0.4;
        setShowMenu(window.pageYOffset > windowPosition);
    });
    var handleLinkClick = function(targetSection) {
        var targetElement = document.getElementById(targetSection);
        if (targetElement) targetElement.scrollIntoView({
            behavior: "smooth"
        });
    };
    // Forcing the character case because client doesn't want to change in CMS.
    var foreName = "".concat((firstName === null || firstName === void 0 ? void 0 : firstName.toLowerCase()) || "");
    var surnameName = "".concat((lastName === null || lastName === void 0 ? void 0 : lastName.toLowerCase()) || "");
    // This here is a very important data structure as it's what we use to put together a lot of the gallery content for a model
    // Annoyingly, it seems that two of the public_galleries entries are not pluralised in the way that the old galleries were
    // They are 'runway' and 'polaroid'. So these need changing to their plurals below (which is a little annoying)
    var annoyingSwitchType = {
        runway: "runways",
        polaroid: "polaroids"
    };
    var annoyingSwitchTypeName = {
        Runway: "Runways",
        Polaroid: "Polaroids"
    };
    var allContent = [
        {
            type: "bio",
            typeName: "Bio",
            bio: bio,
            scrollSpyId: "bio",
            isVisibleOnDesktop: false
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(galleries.map(function(gallery) {
        var _type, _typeName;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gallery), {
            type: (_type = annoyingSwitchType[gallery.type]) !== null && _type !== void 0 ? _type : gallery.type,
            typeName: (_typeName = annoyingSwitchTypeName[gallery.typeName]) !== null && _typeName !== void 0 ? _typeName : gallery.typeName,
            scrollSpyId: gallery.type,
            isVisibleOnDesktop: true
        });
    })), (0,_to_consumable_array/* default */.Z)(books === null || books === void 0 ? void 0 : books.map(function(book) {
        return {
            type: "books",
            typeName: book.name,
            assets: book.assets,
            slug: book.slug,
            scrollSpyId: "book_".concat(book.slug),
            isVisibleOnDesktop: true
        };
    })));
    var getContentItem = function(contentItem) {
        var portfolioLink = "".concat(constants/* LIVE_SITE_CMS */.ye, "/api/portfolio.php?agency=").concat(site, "&model=").concat(slug, "&action=portfolio");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
            className: contentItem.isVisibleOnDesktop ? (ModelGallery_module_default()).linkWrapper : (ModelGallery_module_default()).linkWrapperHidden,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        return handleLinkClick(contentItem.scrollSpyId);
                    },
                    // to={`${url}`}
                    className: (ModelGallery_module_default()).link,
                    children: contentItem.typeName
                }),
                contentItem.type === "portfolio" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: portfolioLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (ModelGallery_module_default()).portfolioLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: download,
                                alt: "Download portfolio",
                                width: 15,
                                height: 15
                            })
                        })
                    })
                })
            ]
        }, contentItem.scrollSpyId);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ModelGallery_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((ModelGallery_module_default()).menu, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (ModelGallery_module_default()).menuVisible, showMenu), (0,_define_property/* default */.Z)(_obj, (ModelGallery_module_default()).menuHidden, !showMenu), _obj)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (ModelGallery_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: foreName
                            }),
                            lastName && lastName !== "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: surnameName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModelGallery_module_default()).links,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(scrollspy/* default */.Z, {
                                items: allContent.map(function(contentItem) {
                                    return contentItem.scrollSpyId;
                                }),
                                offset: -200,
                                currentClassName: (ModelGallery_module_default()).linkActive,
                                componentTag: "div",
                                children: [
                                    allContent.map(function(contentItem) {
                                        return getContentItem(contentItem);
                                    }),
                                    (bookers === null || bookers === void 0 ? void 0 : bookers.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: (ModelGallery_module_default()).linkWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: classnames_default()((ModelGallery_module_default()).link, (ModelGallery_module_default()).enquire, (0,_define_property/* default */.Z)({}, (ModelGallery_module_default()).linkActive, emailsVisible === true)),
                                                    onClick: function(e) {
                                                        return toggleEmails(e);
                                                    },
                                                    onBlur: function() {
                                                        return setEmailsVisible(false);
                                                    },
                                                    children: "Enquire"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((ModelGallery_module_default()).emails, (0,_define_property/* default */.Z)({}, (ModelGallery_module_default()).emailsVisible, emailsVisible === true)),
                                                children: bookers.map(function(param) {
                                                    var acfTeamMembers = param.acfTeamMembers;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                        href: "mailto:".concat(bookers.map(function(e) {
                                                            var ref;
                                                            return (ref = e.acfTeamMembers) === null || ref === void 0 ? void 0 : ref.email;
                                                        }).join(","), "?subject=").concat(firstName).concat(lastName ? "%20".concat(lastName) : "", "%20-%20Enquiry&body=https://www.selectmodel.com").concat(url),
                                                        className: (ModelGallery_module_default()).email,
                                                        children: acfTeamMembers === null || acfTeamMembers === void 0 ? void 0 : acfTeamMembers.email
                                                    }, acfTeamMembers === null || acfTeamMembers === void 0 ? void 0 : acfTeamMembers.email);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InstagramCount, {
                                instagram: instagram
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TiktokCount, {
                                tiktok: tiktok
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelGallery_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModelContent, (0,_object_spread/* default */.Z)({
                    activeSection: activeSection,
                    fallbackImg: fallbackImg,
                    allContent: allContent
                }, props))
            })
        ]
    });
};
ModelGallery.propTypes = {
    fallbackImg: (prop_types_default()).bool,
    instagram: (prop_types_default()).array,
    tiktok: (prop_types_default()).array,
    firstName: (prop_types_default()).string,
    lastName: (prop_types_default()).string,
    props: (prop_types_default()).object
};
ModelGallery.defaultProps = {
    fallbackImg: false,
    instagram: [],
    tiktok: [],
    firstName: "",
    lastName: "",
    props: {}
};
/* harmony default export */ var components_ModelGallery = (ModelGallery);

;// CONCATENATED MODULE: ./components/ModelPage/index.js






















function ModelPage(_param) {
    var modelSlug = _param.modelSlug, site = _param.site, title = _param.title, url = _param.url, seo = _param.seo, gender = _param.gender, firstName = _param.firstName, lastName = _param.lastName, instagramCount = _param.instagramCount, instagram = _param.instagram, tiktokCount = _param.tiktokCount, tiktok = _param.tiktok, measurements = _param.measurements, image = _param.image, uiColour = _param.uiColour, uiLogoColour = _param.uiLogoColour, globalSettings = _param.globalSettings, galleries = _param.galleries, props = (0,_object_without_properties/* default */.Z)(_param, [
        "modelSlug",
        "site",
        "title",
        "url",
        "seo",
        "gender",
        "firstName",
        "lastName",
        "instagramCount",
        "instagram",
        "tiktokCount",
        "tiktok",
        "measurements",
        "image",
        "uiColour",
        "uiLogoColour",
        "globalSettings",
        "galleries"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var state = (0,react.useContext)(GlobalContextProvider/* GlobalStateContext */.Pn);
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(""), headerColour = ref6[0], setHeaderColour = ref6[1];
    var ref7 = (0,react.useState)(false), mobileMenu = ref7[0], setMobileMenu = ref7[1];
    var ref8 = (0,react.useState)("Share Model"), shareText = ref8[0], setShareText = ref8[1];
    var ref9 = (0,react.useState)(null), timeoutId = ref9[0], setTimeoutId = ref9[1];
    var ref10 = (0,react.useState)(false), emailsVisible = ref10[0], setEmailsVisible = ref10[1];
    var headerScrolled = state === null || state === void 0 ? void 0 : (ref = state.header) === null || ref === void 0 ? void 0 : (ref1 = ref.scrolled) === null || ref1 === void 0 ? void 0 : ref1.scrolled;
    var pageLink = "".concat(constants/* LIVE_SITE_URL */.WJ).concat(router.asPath);
    // const enableTikTok =
    //   parseInt(process.env.NEXT_PUBLIC_ENABLE_TIKTOK ?? '0', 10) === 1
    // const enableTikTokCount =
    //   parseInt(process.env.NEXT_PUBLIC_ENABLE_TIKTOK_COUNT ?? '0', 10) === 1
    var isLightUi = uiColour === "light";
    var isDarkUi = uiColour === "dark";
    var isLightLogo = uiLogoColour === "light";
    var isDarkLogo = uiLogoColour === "dark";
    (0,useClearTimeout/* default */.Z)(timeoutId);
    (0,react.useEffect)(function() {
        var doc = document.documentElement;
        var headerAttr = "data-header-color";
        if (isLightUi && isDarkLogo && !headerScrolled) {
            setHeaderColour("light-ui-dark-logo");
            doc.setAttribute(headerAttr, headerColour);
        } else if (isDarkUi && isLightLogo && !headerScrolled) {
            setHeaderColour("dark-ui-light-logo");
            doc.setAttribute(headerAttr, headerColour);
        } else if (isLightUi && isLightLogo && !headerScrolled) {
            setHeaderColour("light");
            doc.setAttribute(headerAttr, headerColour);
        } else {
            setHeaderColour("");
            doc.setAttribute(headerAttr, headerColour);
        }
    }, [
        state,
        headerScrolled,
        uiColour,
        uiLogoColour
    ]);
    var setInstagram = instagram ? [
        {
            username: instagram
        },
        {
            count: instagramCount
        }
    ] : null;
    var setTiktok = tiktok ? [
        {
            username: tiktok
        },
        {
            count: tiktokCount
        }
    ] : null;
    var setMeasurements = function() {
        var classname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (!measurements) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelMeasurements/* default */.Z, {
            className: classnames_default()((model_module_default()).measurementsWrapper, classname),
            listClassName: (model_module_default()).measurements,
            itemClassName: (model_module_default()).measurement,
            valueClassName: (model_module_default()).measurementValue,
            measurements: measurements,
            shoesToggle: true,
            mobile: isMobile,
            male: (typeof gender === "string" || (0,_instanceof/* default */.Z)(gender, String)) && gender.toLowerCase() === "male"
        });
    };
    var handleOpenMenu = function() {
        setMobileMenu(true);
        (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)();
    };
    var handleCloseMenu = function() {
        setMobileMenu(false);
        (0,bodyScrollLock_esm/* clearAllBodyScrollLocks */.tP)();
    };
    var handleEmailToggle = function() {
        setEmailsVisible(!emailsVisible);
    };
    var handleShare = function() {
        var copyLink = document.getElementById("model-share-link");
        copyLink.select();
        document.execCommand("copy");
        setShareText("Link copied");
        var timeoutId = setTimeout(function() {
            setShareText("Share Model");
        }, 1000);
        setTimeoutId(timeoutId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                url: url || "/".concat(site, "/model/").concat(modelSlug),
                title: title,
                seo: seo,
                image: image === null || image === void 0 ? void 0 : image.sourceUrl,
                canonical: "/".concat(site, "/model/").concat(modelSlug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((model_module_default()).mobileHeader, (0,_define_property/* default */.Z)({}, (model_module_default()).mobileMenuVisible, mobileMenu === true)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                        className: (model_module_default()).mobileBackBtn,
                        fallback: ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.boardType) ? "".concat(site, "/").concat((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.boardType) : site
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (model_module_default()).mobileTitle,
                        dangerouslySetInnerHTML: {
                            __html: "".concat(firstName, " ").concat(lastName || "")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (model_module_default()).mobileMenuBtn,
                        onClick: handleOpenMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (model_module_default()).mobileMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (model_module_default()).mobileMenuItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: (model_module_default()).shareBtn,
                                onClick: handleShare,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (model_module_default()).mobileMenuLabel,
                                        children: shareText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "model-share-link",
                                        className: (model_module_default()).shareLink,
                                        type: "text",
                                        defaultValue: pageLink
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (model_module_default()).closeMenuBtn,
                        onClick: handleCloseMenu
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModelHeader, {
                coverImage: image === null || image === void 0 ? void 0 : image.sourceUrl,
                firstName: firstName,
                lastName: lastName,
                bio: props.bio,
                instagram: setInstagram,
                tiktok: setTiktok,
                uiColour: isLightUi,
                logoColour: isLightLogo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (model_module_default()).mobileInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        className: (model_module_default()).title,
                        title: firstName,
                        subtitle: lastName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InstagramCount, {
                        className: (model_module_default()).social,
                        instagram: setInstagram
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TiktokCount, {
                        className: (model_module_default()).social,
                        tiktok: setTiktok
                    }),
                    ((ref4 = props.bookers) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: classnames_default()((model_module_default()).toggleEmails, (0,_define_property/* default */.Z)({}, (model_module_default()).toggleEmailsVisible, emailsVisible)),
                                onClick: handleEmailToggle,
                                children: "Enquire"
                            }),
                            emailsVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (model_module_default()).emails,
                                children: (ref5 = props.bookers) === null || ref5 === void 0 ? void 0 : ref5.map(function(param) {
                                    var acfTeamMembers = param.acfTeamMembers;
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:".concat((ref = props.bookers) === null || ref === void 0 ? void 0 : ref.map(function(e) {
                                            var ref;
                                            return (ref = e.acfTeamMembers) === null || ref === void 0 ? void 0 : ref.email;
                                        }).join(","), "?subject=").concat(firstName).concat(lastName ? "%20".concat(lastName) : "", "%20-%20Enquiry&body=https://www.selectmodel.com/").concat(site, "/model/").concat(modelSlug),
                                        className: (model_module_default()).email,
                                        children: acfTeamMembers === null || acfTeamMembers === void 0 ? void 0 : acfTeamMembers.email
                                    }, acfTeamMembers === null || acfTeamMembers === void 0 ? void 0 : acfTeamMembers.email);
                                })
                            })
                        ]
                    }),
                    setMeasurements((model_module_default()).measurementsWrapperMobile, true)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModelGallery, {
                fallbackImg: true,
                instagram: setInstagram,
                tiktok: setTiktok,
                firstName: firstName,
                lastName: lastName,
                galleries: galleries,
                props: props
            }),
            setMeasurements((model_module_default()).measurementsWrapperDesktop)
        ]
    });
}
ModelPage.propTypes = {
    pageUrl: (prop_types_default()).string,
    pageTitle: (prop_types_default()).string,
    pageDesc: (prop_types_default()).string,
    seo: (prop_types_default()).object,
    gender: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).oneOfType["null"]
    ]),
    firstName: (prop_types_default()).string,
    lastName: (prop_types_default()).string,
    instagramCount: (prop_types_default()).number,
    instagram: (prop_types_default()).string,
    tiktokCount: (prop_types_default()).number,
    tiktok: (prop_types_default()).string,
    measurements: (prop_types_default()).array,
    image: (prop_types_default()).object,
    uiColour: (prop_types_default()).string,
    uiLogoColour: (prop_types_default()).string,
    globalSettings: (prop_types_default()).object,
    props: (prop_types_default()).object
};
ModelPage.defaultProps = {
    pageUrl: "",
    pageTitle: "",
    pageDesc: "",
    seo: {},
    gender: null,
    firstName: "",
    lastName: "",
    instagramCount: 0,
    instagram: "",
    tiktokCount: 0,
    tiktok: "",
    measurements: [],
    image: {},
    uiColour: "dark",
    uiLogoColour: "dark",
    globalSettings: {},
    props: {}
};
/* harmony default export */ var components_ModelPage = (ModelPage);


/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8735);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Title_module_css__WEBPACK_IMPORTED_MODULE_2__);





function Title(param) {
    var title = param.title, subtitle = param.subtitle, swapColour = param.swapColour, lightUi = param.lightUi, borderTitle = param.borderTitle, lightSubtitle = param.lightSubtitle, className = param.className, shrinkSubtitleLength = param.shrinkSubtitleLength;
    if (!title) return null;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().swapColour), swapColour), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightUi), lightUi), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().borderTitle), borderTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightSubtitle), lightSubtitle), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitleLong), shrinkSubtitleLength && subtitle.length > shrinkSubtitleLength)),
                dangerouslySetInnerHTML: {
                    __html: subtitle
                }
            })
        ]
    });
}
Title.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    swapColour: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightUi: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    borderTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    shrinkSubtitleLength: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};
Title.defaultProps = {
    title: "",
    subtitle: "",
    swapColour: false,
    lightUi: false,
    borderTitle: false,
    lightSubtitle: false,
    className: "",
    shrinkSubtitleLength: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 1610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var html_entities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9111);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7821);
/* harmony import */ var helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var _helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2084);








var htmlEntities = new html_entities__WEBPACK_IMPORTED_MODULE_3__/* .Html5Entities */ .JK();
function htmlDecode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return htmlEntities.decode(string);
}
function WordpressSEO(param) {
    var url = param.url, title = param.title, seo = param.seo, image = param.image, desc = param.desc, _canonical = param.canonical, canonical = _canonical === void 0 ? null : _canonical;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var siteName;
    var fallbackTitle;
    var siteLogo;
    if ((0,_helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)()) {
        siteName = "Modellink";
        fallbackTitle = "".concat(htmlDecode(title), " | ").concat(siteName);
        siteLogo = "/img/logo/modellink.jpg";
    } else {
        var ref2;
        siteName = "Select Model Management";
        fallbackTitle = "".concat(htmlDecode(title)).concat(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.site) ? " | Select ".concat((0,helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(router.query.site)) : "", " | ").concat(siteName);
        siteLogo = "/img/logo/selectmodel.jpg";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seo && seo.title ? htmlDecode(seo.title) : fallbackTitle,
        description: (seo === null || seo === void 0 ? void 0 : seo.metaDesc) || desc || siteName,
        openGraph: {
            title: seo === null || seo === void 0 ? void 0 : seo.title,
            url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(url),
            description: seo === null || seo === void 0 ? void 0 : seo.metaDesc,
            images: [
                {
                    url: image || (seo === null || seo === void 0 ? void 0 : (ref = seo.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(siteLogo)
                }, 
            ]
        },
        canonical: canonical
    });
}
WordpressSEO.propTypes = {
    url: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    desc: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    image: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    canonical: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    seo: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
WordpressSEO.defaultProps = {
    url: "",
    title: "",
    desc: null,
    image: "",
    seo: {},
    canonical: null
};
/* harmony default export */ __webpack_exports__["Z"] = (WordpressSEO);


/***/ }),

/***/ 406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uppercaseFirst; }
/* harmony export */ });
function uppercaseFirst(string) {
    if (!string) return null;
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substring(1));
}


/***/ }),

/***/ 662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClearTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useClearTimeout(id) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            clearTimeout(id);
        };
    }, [
        id
    ]);
}


/***/ }),

/***/ 6749:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BackButton_spacing--xxxs__gjTE3","spacing--xxs":"BackButton_spacing--xxs__rSADE","spacing--xs":"BackButton_spacing--xs__8FF69","spacing--sm":"BackButton_spacing--sm___Bx45","spacing--md":"BackButton_spacing--md__AjHcV","spacing--lg":"BackButton_spacing--lg__3JElb","spacing--xl":"BackButton_spacing--xl__UL58X","spacing--xxl":"BackButton_spacing--xxl__wKmK5","spacing--xxxl":"BackButton_spacing--xxxl__HTVAR","container":"BackButton_container__8wlKy","btn":"BackButton_btn__T6gpu","fadeInItems":"BackButton_fadeInItems__MtLQK"};

/***/ }),

/***/ 5485:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"InstagramCount_spacing--xxxs__h0XD9","spacing--xxs":"InstagramCount_spacing--xxs__mIeru","spacing--xs":"InstagramCount_spacing--xs__Kwi6s","spacing--sm":"InstagramCount_spacing--sm__eKGEX","spacing--md":"InstagramCount_spacing--md__ybw7y","spacing--lg":"InstagramCount_spacing--lg__xYWyM","spacing--xl":"InstagramCount_spacing--xl__M82Gh","spacing--xxl":"InstagramCount_spacing--xxl__FfRsc","spacing--xxxl":"InstagramCount_spacing--xxxl__BdyZh","container":"InstagramCount_container__yfUzK","user":"InstagramCount_user__H7PHi","count":"InstagramCount_count__CIwIE","icon":"InstagramCount_icon__WWrdz","userText":"InstagramCount_userText__GiZP1","marquee":"InstagramCount_marquee__78O7U","fadeInItems":"InstagramCount_fadeInItems__rDdZb"};

/***/ }),

/***/ 1627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Layout_spacing--xxxs__8iHw7","spacing--xxs":"Layout_spacing--xxs__rg8b2","spacing--xs":"Layout_spacing--xs__dO6OG","spacing--sm":"Layout_spacing--sm__jhGe9","spacing--md":"Layout_spacing--md__vIpF7","spacing--lg":"Layout_spacing--lg__fEe2_","spacing--xl":"Layout_spacing--xl__dhV28","spacing--xxl":"Layout_spacing--xxl__K3sH1","spacing--xxxl":"Layout_spacing--xxxl__Bs9tG","main":"Layout_main__gbdP0","fadeInItems":"Layout_fadeInItems__QzPHk"};

/***/ }),

/***/ 888:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Bio_spacing--xxxs__AOMjU","spacing--xxs":"Bio_spacing--xxs__KxawI","spacing--xs":"Bio_spacing--xs__JqsLr","spacing--sm":"Bio_spacing--sm__C4L5b","spacing--md":"Bio_spacing--md__Q9HeU","spacing--lg":"Bio_spacing--lg__LrBIO","spacing--xl":"Bio_spacing--xl__FlUga","spacing--xxl":"Bio_spacing--xxl__1KoM5","spacing--xxxl":"Bio_spacing--xxxl__Vrwn0","wrapper":"Bio_wrapper__xVFKU","container":"Bio_container__n1uEC","fadeInItems":"Bio_fadeInItems__ffJQq"};

/***/ }),

/***/ 9855:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Covers_spacing--xxxs__rbgr_","spacing--xxs":"Covers_spacing--xxs__e_1p9","spacing--xs":"Covers_spacing--xs__lFB2Y","spacing--sm":"Covers_spacing--sm__1AYem","spacing--md":"Covers_spacing--md__5JAQH","spacing--lg":"Covers_spacing--lg__HTrZ6","spacing--xl":"Covers_spacing--xl__384Oq","spacing--xxl":"Covers_spacing--xxl__w_SSj","spacing--xxxl":"Covers_spacing--xxxl__MlDWr","row":"Covers_row__glmoV","imageWrapper":"Covers_imageWrapper__oTPJI","imageBackground":"Covers_imageBackground__cGSf7","image":"Covers_image__o5eF6","fadeInItems":"Covers_fadeInItems__cIXO_"};

/***/ }),

/***/ 3128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"LightboxButton_spacing--xxxs__qi2xW","spacing--xxs":"LightboxButton_spacing--xxs__BOEsS","spacing--xs":"LightboxButton_spacing--xs__JSKhY","spacing--sm":"LightboxButton_spacing--sm__PTVHb","spacing--md":"LightboxButton_spacing--md__YonJ3","spacing--lg":"LightboxButton_spacing--lg__2uAiW","spacing--xl":"LightboxButton_spacing--xl__mvO27","spacing--xxl":"LightboxButton_spacing--xxl__ulUSd","spacing--xxxl":"LightboxButton_spacing--xxxl__O57CL","container":"LightboxButton_container__wvvXG","fadeInItems":"LightboxButton_fadeInItems__9GRC8"};

/***/ }),

/***/ 359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ModelContent_spacing--xxxs__fz28x","spacing--xxs":"ModelContent_spacing--xxs__UCZPq","spacing--xs":"ModelContent_spacing--xs__u_qZb","spacing--sm":"ModelContent_spacing--sm__7m0GE","spacing--md":"ModelContent_spacing--md__prdb8","spacing--lg":"ModelContent_spacing--lg__ylqch","spacing--xl":"ModelContent_spacing--xl__T5m2T","spacing--xxl":"ModelContent_spacing--xxl__TOjnR","spacing--xxxl":"ModelContent_spacing--xxxl__BMGXG","container":"ModelContent_container__Q1IuK","row":"ModelContent_row__9FgX9","title":"ModelContent_title__Z72OI","expander":"ModelContent_expander__2Z84L","fadeInItems":"ModelContent_fadeInItems__jKFLy"};

/***/ }),

/***/ 6544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Polaroids_spacing--xxxs__i_olc","spacing--xxs":"Polaroids_spacing--xxs__dX2_m","spacing--xs":"Polaroids_spacing--xs__tf1p0","spacing--sm":"Polaroids_spacing--sm__bZBB0","spacing--md":"Polaroids_spacing--md__wWJNW","spacing--lg":"Polaroids_spacing--lg__boJMJ","spacing--xl":"Polaroids_spacing--xl__T6I0Y","spacing--xxl":"Polaroids_spacing--xxl__jd_aT","spacing--xxxl":"Polaroids_spacing--xxxl___eb8V","row":"Polaroids_row__CWJln","imageWrapper":"Polaroids_imageWrapper__Sdjy5","imageWrapperLandscape":"Polaroids_imageWrapperLandscape__jUicM","image":"Polaroids_image__aBtNB","imageResized":"Polaroids_imageResized__g_KSQ","imageRatio":"Polaroids_imageRatio__kw3U0","fadeInItems":"Polaroids_fadeInItems__S1ld7"};

/***/ }),

/***/ 5199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Portfolio_spacing--xxxs__GR1sL","spacing--xxs":"Portfolio_spacing--xxs__k982J","spacing--xs":"Portfolio_spacing--xs__1gTdj","spacing--sm":"Portfolio_spacing--sm__MtHi_","spacing--md":"Portfolio_spacing--md__id2u3","spacing--lg":"Portfolio_spacing--lg__GpWKu","spacing--xl":"Portfolio_spacing--xl__ECFiF","spacing--xxl":"Portfolio_spacing--xxl__Loo3w","spacing--xxxl":"Portfolio_spacing--xxxl__kOCaY","row":"Portfolio_row__SfGSH","imageWrapper":"Portfolio_imageWrapper__wJwDh","imageWrapperLandscape":"Portfolio_imageWrapperLandscape__XN5FI","image":"Portfolio_image__v9bsr","imageResized":"Portfolio_imageResized__7paLb","imageRatio":"Portfolio_imageRatio__k09o1","fadeInItems":"Portfolio_fadeInItems__KAyIX"};

/***/ }),

/***/ 584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Video_spacing--xxxs__UJXQp","spacing--xxs":"Video_spacing--xxs__rNXDj","spacing--xs":"Video_spacing--xs__9yWMb","spacing--sm":"Video_spacing--sm__TO2X9","spacing--md":"Video_spacing--md__yXn8q","spacing--lg":"Video_spacing--lg___pk92","spacing--xl":"Video_spacing--xl__jJLLp","spacing--xxl":"Video_spacing--xxl__kBgmu","spacing--xxxl":"Video_spacing--xxxl__dHCFN","video":"Video_video__VIoQy","fadeInItems":"Video_fadeInItems__UIjYp"};

/***/ }),

/***/ 6128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ModelGallery_spacing--xxxs__RAYX0","spacing--xxs":"ModelGallery_spacing--xxs__3tnfV","spacing--xs":"ModelGallery_spacing--xs__fVvog","spacing--sm":"ModelGallery_spacing--sm__rCs2m","spacing--md":"ModelGallery_spacing--md__5ajKp","spacing--lg":"ModelGallery_spacing--lg__80w85","spacing--xl":"ModelGallery_spacing--xl__Lz4bK","spacing--xxl":"ModelGallery_spacing--xxl__pAT0v","spacing--xxxl":"ModelGallery_spacing--xxxl__5wZf_","container":"ModelGallery_container__7zOyC","menu":"ModelGallery_menu__Z7sxH","menuVisible":"ModelGallery_menuVisible__eX_eb","menuHidden":"ModelGallery_menuHidden___E_MY","content":"ModelGallery_content__GoJPW","title":"ModelGallery_title__ONERg","links":"ModelGallery_links__V1Mqw","linkWrapperHidden":"ModelGallery_linkWrapperHidden__3SB5_","linkWrapper":"ModelGallery_linkWrapper___lNQQ","link":"ModelGallery_link__t7Hhg","enquire":"ModelGallery_enquire__yZbx_","linkActive":"ModelGallery_linkActive__xBSfY","portfolioLink":"ModelGallery_portfolioLink__0VMaZ","emails":"ModelGallery_emails__3cTGV","emailsVisible":"ModelGallery_emailsVisible__f6ox6","email":"ModelGallery_email__rvtBl","fadeInItems":"ModelGallery_fadeInItems__15PJ5"};

/***/ }),

/***/ 2085:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"HeaderBio_spacing--xxxs__JeCo9","spacing--xxs":"HeaderBio_spacing--xxs__IMpeX","spacing--xs":"HeaderBio_spacing--xs__J4Lak","spacing--sm":"HeaderBio_spacing--sm__53di_","spacing--md":"HeaderBio_spacing--md__LZDvT","spacing--lg":"HeaderBio_spacing--lg__ytMjt","spacing--xl":"HeaderBio_spacing--xl__oPRK0","spacing--xxl":"HeaderBio_spacing--xxl__aDRGT","spacing--xxxl":"HeaderBio_spacing--xxxl__vlANa","wrapper":"HeaderBio_wrapper__zK6YD","container":"HeaderBio_container__mhdk0","collapse":"HeaderBio_collapse__IJNml","expander":"HeaderBio_expander__Tj_gP","fadeInItems":"HeaderBio_fadeInItems__OGfYz"};

/***/ }),

/***/ 286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ModelHeader_spacing--xxxs__MJz_d","spacing--xxs":"ModelHeader_spacing--xxs__KySC8","spacing--xs":"ModelHeader_spacing--xs__gTwgj","spacing--sm":"ModelHeader_spacing--sm__Kgki0","spacing--md":"ModelHeader_spacing--md__gMyNp","spacing--lg":"ModelHeader_spacing--lg__GtJT9","spacing--xl":"ModelHeader_spacing--xl__LlSQe","spacing--xxl":"ModelHeader_spacing--xxl__XUkl1","spacing--xxxl":"ModelHeader_spacing--xxxl__ybll2","container":"ModelHeader_container__gfKnS","containerPortrait":"ModelHeader_containerPortrait__s3wct","text":"ModelHeader_text__XCXZ3","imgHalfWrap":"ModelHeader_imgHalfWrap__aSkfF","imgHalf":"ModelHeader_imgHalf__eNzyD","img":"ModelHeader_img__YmgN5","squareLayout":"ModelHeader_squareLayout__iGFHu","textContent":"ModelHeader_textContent__H9RqG","titleContainer":"ModelHeader_titleContainer__HZqfw","textVisible":"ModelHeader_textVisible___oLi_","textHidden":"ModelHeader_textHidden__7M8Ul","title":"ModelHeader_title__wNN0d","socialStats":"ModelHeader_socialStats__gdDVU","fadeInItems":"ModelHeader_fadeInItems__VlgcG"};

/***/ }),

/***/ 5193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OutdatedBrowser_spacing--xxxs__Accab","spacing--xxs":"OutdatedBrowser_spacing--xxs__i92K8","spacing--xs":"OutdatedBrowser_spacing--xs__zWpQI","spacing--sm":"OutdatedBrowser_spacing--sm__Vrmq_","spacing--md":"OutdatedBrowser_spacing--md__vcPS_","spacing--lg":"OutdatedBrowser_spacing--lg__SYnnw","spacing--xl":"OutdatedBrowser_spacing--xl__Mc5r2","spacing--xxl":"OutdatedBrowser_spacing--xxl___59QJ","spacing--xxxl":"OutdatedBrowser_spacing--xxxl__S_A_A","container":"OutdatedBrowser_container__5_uvZ","title":"OutdatedBrowser_title___0088","text":"OutdatedBrowser_text__aSnM3","link":"OutdatedBrowser_link__HM2Bc","btn":"OutdatedBrowser_btn__r3Ac0","fadeInItems":"OutdatedBrowser_fadeInItems__7725t"};

/***/ }),

/***/ 6667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"TiktokCount_spacing--xxxs__LeI88","spacing--xxs":"TiktokCount_spacing--xxs__p566k","spacing--xs":"TiktokCount_spacing--xs__jKg5Z","spacing--sm":"TiktokCount_spacing--sm__XqUeb","spacing--md":"TiktokCount_spacing--md__h2N08","spacing--lg":"TiktokCount_spacing--lg__rZKcR","spacing--xl":"TiktokCount_spacing--xl__wfvVI","spacing--xxl":"TiktokCount_spacing--xxl__CjSVF","spacing--xxxl":"TiktokCount_spacing--xxxl__pE206","container":"TiktokCount_container__Ug44O","user":"TiktokCount_user__JLyAu","count":"TiktokCount_count__KL4_6","icon":"TiktokCount_icon__bvTdZ","userText":"TiktokCount_userText__Dmk2J","marquee":"TiktokCount_marquee__8o1TM","fadeInItems":"TiktokCount_fadeInItems__Fqb0n"};

/***/ }),

/***/ 8735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Title_spacing--xxxs__sEhJq","spacing--xxs":"Title_spacing--xxs__DgJXk","spacing--xs":"Title_spacing--xs__DA8px","spacing--sm":"Title_spacing--sm__AvCBI","spacing--md":"Title_spacing--md__n1H3y","spacing--lg":"Title_spacing--lg___qrsK","spacing--xl":"Title_spacing--xl__7hIyQ","spacing--xxl":"Title_spacing--xxl__Eoec_","spacing--xxxl":"Title_spacing--xxxl__0Xl1t","container":"Title_container__5MuPN","swapColour":"Title_swapColour__Csfih","subtitle":"Title_subtitle__t4Jhl","lightUi":"Title_lightUi__owagC","borderTitle":"Title_borderTitle__opYdU","subtitleLong":"Title_subtitleLong__7K7dp","lightSubtitle":"Title_lightSubtitle__iCTJ6","fadeInItems":"Title_fadeInItems___Zi_4"};

/***/ }),

/***/ 2309:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"model_spacing--xxxs__qS3ZN","spacing--xxs":"model_spacing--xxs__awRcK","spacing--xs":"model_spacing--xs__7_0YI","spacing--sm":"model_spacing--sm__sPAuS","spacing--md":"model_spacing--md__7ubSJ","spacing--lg":"model_spacing--lg__7Tr7h","spacing--xl":"model_spacing--xl__vC36w","spacing--xxl":"model_spacing--xxl__1bn0M","spacing--xxxl":"model_spacing--xxxl__MggDg","container":"model_container__ej72X","cover":"model_cover__De_hl","coverInfo":"model_coverInfo__00J_0","mobileHeader":"model_mobileHeader__o1Fel","mobileMenuVisible":"model_mobileMenuVisible__ijKGF","mobileMenu":"model_mobileMenu__R3trn","closeMenuBtn":"model_closeMenuBtn__kHWDx","mobileTitle":"model_mobileTitle__Hs4jP","mobileBackBtn":"model_mobileBackBtn__KCb6N","mobileInfo":"model_mobileInfo__EdmJJ","mobileMenuBtn":"model_mobileMenuBtn__4v7vF","mobileMenuLabel":"model_mobileMenuLabel__nx7H1","mobileMenuItem":"model_mobileMenuItem__2kLNk","shareBtn":"model_shareBtn__Nw7BJ","shareLink":"model_shareLink__hosFV","title":"model_title__7yy_L","social":"model_social__zZIKZ","slider":"model_slider__UIoCV","sliderDots":"model_sliderDots__z_qWy","slide":"model_slide__MqXuy","measurementsWrapper":"model_measurementsWrapper__6GCiI","measurementsWrapperMobile":"model_measurementsWrapperMobile__vRJ_v","measurementsWrapperDesktop":"model_measurementsWrapperDesktop__YjANl","measurements":"model_measurements__X5hH_","measurement":"model_measurement__qrs0R","measurementValue":"model_measurementValue__PMyuj","toggleEmails":"model_toggleEmails__eRGiD","toggleEmailsVisible":"model_toggleEmailsVisible__KCgQ6","emails":"model_emails__0vz4c","email":"model_email__ODzJb","fadeInItems":"model_fadeInItems__1obI6"};

/***/ })

}]);